(function () {
  function isTypingTarget(el) {
    if (!el) return false;
    var tag = el.tagName;
    return tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || el.isContentEditable;
  }

  function isInViewport(el) {
    var rect = el.getBoundingClientRect();
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    if (rect.height === 0 || rect.width === 0) return false;
    var visibleTop = Math.max(rect.top, 0);
    var visibleBottom = Math.min(rect.bottom, viewportHeight);
    var visibleHeight = Math.max(0, visibleBottom - visibleTop);
    var horizontallyVisible = rect.left < viewportWidth && rect.right > 0;
    return horizontallyVisible && (visibleHeight / rect.height) >= 0.3;
  }

  function findVisibleSlideshow() {
    var slideshows = document.querySelectorAll('slideshow-component');
    for (var i = 0; i < slideshows.length; i++) {
      if (isInViewport(slideshows[i])) return slideshows[i];
    }
    return null;
  }

  function handleKeydown(event) {
    if (event.defaultPrevented) return;
    if (isTypingTarget(event.target)) return;
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;

    var slideshow = findVisibleSlideshow();
    if (!slideshow) return;

    var selector = event.key === 'ArrowLeft' ? 'button[name="previous"]' : 'button[name="next"]';
    var button = slideshow.querySelector(selector);
    if (button && !button.disabled) {
      event.preventDefault();
      button.click();
    }
  }

  function init() {
    document.addEventListener('keydown', handleKeydown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
